
(function () {
  function selectedOffer(root) { return root.querySelector('.bl-offer.is-selected') || root.querySelector('.bl-offer'); }
  /* une ligne = une unite : liste unique (.bl-vsel__s) ou une liste par option (.bl-vsel__o) */
  function vmap(el) {
    var b = el.closest('.bl-bundle'); if (!b) return [];
    if (!b._blVmap) { var s = b.querySelector('[data-bl-vmap]'); try { b._blVmap = s ? JSON.parse(s.textContent) : []; } catch (err) { b._blVmap = []; } }
    return b._blVmap;
  }
  function rowMatch(row) {
    var vals = Array.prototype.map.call(row.querySelectorAll('.bl-vsel__o'), function (o) { return o.value; });
    var m = vmap(row).filter(function (v) { return v.o.length === vals.length && v.o.every(function (x, i) { return x === vals[i]; }); });
    return m[0] || null;
  }
  function rowVariant(row) {
    var s = row.querySelector('.bl-vsel__s');
    if (s) return parseInt(s.value, 10);
    var v = rowMatch(row);
    return v ? v.id : null;
  }
  document.addEventListener('change', function (e) {
    var o = e.target.closest('.bl-vsel__o');
    if (!o) return;
    var row = o.closest('.bl-vsel__row'); var v = rowMatch(row);
    var im = row.querySelector('.bl-vsel__img img');
    if (im && v && v.img) { im.removeAttribute('srcset'); im.src = v.img; }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('.bl-offer input');
    if (!input) return;
    var root = input.closest('.bl-bundle');
    root.querySelectorAll('.bl-offer').forEach(function (o) { o.classList.toggle('is-selected', o.contains(input)); });
    var qty = document.querySelector('product-info input[name="quantity"], .product__info-container input[name="quantity"]');
    if (qty) qty.value = input.dataset.qty;
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var info = form.closest('.product__info-container') || document;
    var bundle = document.querySelector('.bl-bundle');
    var upsell = document.querySelector('.bl-upsell input:checked');
    if (!bundle && !upsell) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var productForm = form.closest('product-form');
    var btn = form.querySelector('[name="add"]');
    var variantId = parseInt(new FormData(form).get('id'), 10);
    var qty = parseInt(new FormData(form).get('quantity'), 10) || 1;
    var items = [];
    if (bundle) {
      var offer = selectedOffer(bundle).querySelector('input');
      qty = parseInt(offer.dataset.qty, 10) || 1;
      (offer.dataset.gifts || '').split(',').filter(Boolean).forEach(function (g) { items.push({ id: parseInt(g, 10), quantity: 1 }); });
    }
    if (upsell) items.unshift({ id: parseInt(upsell.value, 10), quantity: 1 });
    var vrows = bundle ? selectedOffer(bundle).querySelectorAll('.bl-vsel__row') : [];
    if (vrows.length) {
      var byId = {};
      vrows.forEach(function (row) { var id = rowVariant(row) || variantId; byId[id] = (byId[id] || 0) + 1; });
      Object.keys(byId).forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: byId[id] }); });
    } else {
      items.push({ id: variantId, quantity: qty });
    }
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
    if (btn) { btn.setAttribute('aria-disabled', true); btn.classList.add('loading'); }
    fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { if (productForm && productForm.handleErrorMessage) productForm.handleErrorMessage(res.description); return; }
        if (!cart) { window.location = window.routes.cart_url; return; }
        try { sessionStorage.removeItem('bl_cart_timer_end'); } catch (err) {}
        cart.classList.remove('is-empty');
        cart.renderContents(res);
      })
      .catch(function () { window.location = window.routes.cart_url; })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.bl-tabs__btn');
    if (b) {
      var wrap = b.closest('.bl-tabs');
      wrap.querySelectorAll('.bl-tabs__btn').forEach(function (x) { x.setAttribute('aria-expanded', x === b ? 'true' : 'false'); });
      wrap.querySelectorAll('.bl-tabs__panel').forEach(function (p) { p.hidden = p.id !== b.getAttribute('aria-controls'); });
    }
    var t = e.target.closest('[data-bl-top]');
    if (t) {
      e.preventDefault();
      var f = document.querySelector('.bl-bundle') || document.querySelector('product-form');
      if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' }); else window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
  function initSliders() {
    document.querySelectorAll('[data-bl-slider]').forEach(function (track) {
      if (track.dataset.blInit) return; track.dataset.blInit = '1';
      var nav = track.parentElement.querySelector('.bl-sl-nav'); if (!nav) return;
      var dots = nav.querySelector('.bl-sl-dots'); var cards = track.children;
      for (var i = 0; i < cards.length; i++) { var d = document.createElement('button'); d.type = 'button'; d.className = 'bl-sl-dot'; d.setAttribute('aria-label', 'Go to slide ' + (i + 1)); (function (n) { d.addEventListener('click', function () { track.scrollTo({ left: cards[n].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' }); }); })(i); dots.appendChild(d); }
      nav.querySelectorAll('.bl-sl-arrow').forEach(function (a) { a.addEventListener('click', function () { track.scrollBy({ left: parseInt(a.dataset.dir, 10) * (cards[0].getBoundingClientRect().width + 24), behavior: 'smooth' }); }); });
      function upd() { var w = cards[0].getBoundingClientRect().width + 24; var idx = Math.round(track.scrollLeft / w); dots.querySelectorAll('.bl-sl-dot').forEach(function (d, k) { d.classList.toggle('is-active', k === idx); }); }
      track.addEventListener('scroll', upd, { passive: true }); upd();
    });
  }
  if (document.readyState !== 'loading') initSliders(); else document.addEventListener('DOMContentLoaded', initSliders);
})();

/* Blushlay : petit carrousel d'avis de la buybox (.blx-mr) */
document.addEventListener('click', function (e) {
  var b = e.target.closest('.blx-mr__prev, .blx-mr__next');
  if (!b) return;
  var root = b.closest('[data-blx-slider]');
  var tr = root.querySelector('.blx-mr__track');
  var w = tr.clientWidth;
  var n = tr.children.length;
  var i = Math.round(tr.scrollLeft / w) + (b.classList.contains('blx-mr__next') ? 1 : -1);
  if (i < 0) i = n - 1;
  if (i >= n) i = 0;
  tr.scrollTo({ left: i * w, behavior: 'smooth' });
});
